<template>
  <div class="GalleryContents container-fluid area_funcontents">
    <div class="container thum_area_funcontents">
      <div class="row other_fun_content_caption">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <h2 class="text-center garally_title">
            <LabelFunMessage fcontId="0" msgkey="55" />
          </h2>
        </div>
      </div>

      <template v-if="articlesStatus">
        <article-tiles :articles="initialDisplayedArticles"></article-tiles>
        <transition name="fade">
          <article-tiles v-if="shouldDisplayAllArticles" :articles="additionalArticles"></article-tiles>
        </transition>
      </template>
    </div>

    <div class="row fun_more">
      <div class="col-lg-12">
        <p class="text-center">
          <a
            class="btn btn-default btn-lg more_button"
            role="button"
            v-show="!shouldDisplayAllArticles"
            v-on:click="appendArticles()"
          >
            <LabelFunMessage fcontId="0" msgkey="3" /> <i class="fa fa-angle-double-down"></i>
          </a>
        </p>
      </div>
    </div>

    <InstaGalleryButton />

    <!-- Ver3.1にて機種トップボタン削除 -->
    <!-- <div class="row">
      <div class="col-lg-12">
        <p class="text-center">
          <FuncSearchProductTop />
        </p>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";
// import FuncSearchProductTop from "./FuncSearchProductTop";
import ArticleTiles from "./ArticleTiles";
import InstaGalleryButton from "./InstaGalleryButton";

export default {
  name: "GalleryContents",
  components: {
    // FuncSearchProductTop,
    LabelFunMessage,
    ArticleTiles,
    InstaGalleryButton
  },
  computed: {
    ...mapState(["shouldDisplayAllArticles"]),
    ...mapState('articles', ['articles', 'articlesStatus', 'firstPriority', 'firstRenderPriority']),
    ...mapState("messages", ["messages"]),

    // 初期表示する記事記事
    initialDisplayedArticles: function() {
      return this.articles.filter(
        article => this.firstPriority < article.priority && article.priority <= this.firstRenderPriority
      )
    },

    additionalArticles: function() {
      // タイル表示するすべての記事
      return this.articles.filter(article => this.firstRenderPriority < article.priority);
    }
  },
  methods: {
    appendArticles: function() {
      // GA4
      this.$gtag.event("tap_button", {
        "custom_parameter1": "more_articles"
      })

      this.$store.commit('setShouldDisplayAllArticles', true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 767px) {
  .thum_area_funcontents {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 0px;
    padding-right: 0px;
  }
}

.fade-enter-active {
  transition: opacity 0.6s;
}
.fade-enter {
  opacity: 0;
}
</style>